import type { FilterSpecification } from "mapbox-gl"
import type { View } from "@/types"

type TransactionFilter = NonNullable<NonNullable<View["filter"]>["transaction"]>

export function transactionRentalIncomeFilter(filter: TransactionFilter | undefined): FilterSpecification {
	const fields = {
		grossAnnualRent: "gross_annual_rent",
		grossMonthlyRentPerUnit: "gross_monthly_rent_per_unit",
		grossRentMultiplier: "gross_rent_multiplier",
	} as const

	return [
		"all",
		...Object.entries(fields).flatMap(([field, property]) => {
			const range = filter?.[field as keyof typeof fields]
			if (range?.min == null && range?.max == null) return []
			return [
				["has", property],
				["!=", ["get", property], null],
				...(range.min != null ? [[">=", ["to-number", ["get", property]], range.min]] : []),
				...(range.max != null ? [["<=", ["to-number", ["get", property]], range.max]] : []),
			]
		}),
	] as FilterSpecification
}
